/*
 * @description: 代理-主菜单
 * @Author: Jay
 * @Date: 2023-04-28 10:02:51
 * @LastEditors: Jay
 * @LastEditTime: 2026-03-02 11:54:57
 */
export const agencMenu = [
    //菜单列表
    {
        path: '/layout',
        name: 'layout',
        component: () => import('../views/layout/menuApp.vue'),
        replace: '/agencyHome',
        meta: {
            //表示需要登录
            requireAuth: true
        },
        children: [
            // 代理首页
            {
                path: '/agencyHome',
                name: 'agencyHome',
                component: () => import('../views/Agency/home/AgencyHome.vue'),
                meta: {
                    title: '首页',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 推荐列表
            {
                path: '/tipList',
                name: 'tipList',
                component: () => import('../views/Agency/Recommend/RecommendList/RecommendList.vue'),
                meta: {
                    title: '推荐列表',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 日推荐收益
            {
                path: '/maturityYield',
                name: 'maturityYield',
                component: () => import('../views/Agency/Recommend/MaturityYield/MaturityYield.vue'),
                meta: {
                    title: '日推荐收益',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 资金记录
            {
                path: '/fundRecord',
                name: 'fundRecord',
                component: () => import('../views/Agency/Finance/FundRecord.vue'),
                meta: {
                    title: '资金记录',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 我的银行卡
            {
                path: '/bankCard',
                name: 'bankCard',
                component: () => import('../views/Agency/Finance/BankCard.vue'),
                meta: {
                    title: '我的银行卡',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 提现记录
            {
                path: '/withdrawRecord',
                name: 'withdrawRecord',
                component: () => import('../views/Agency/Finance/WithdrawRecord.vue'),
                meta: {
                    title: '提现记录',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 提现
            {
                path: '/promptlyWithdraw',
                name: 'promptlyWithdraw',
                component: () => import('../views/Agency/Finance/PromptlyWithdraw.vue'),
                meta: {
                    title: '提现',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["agency"],
                    //表示需要登录
                    requireAuth: true
                }
            },
            // 密码管理
            {
                path: '/keePassDroid',
                name: 'keePassDroid',
                component: () => import('../views/SetView/KeePassDroid/KeePassDroid.vue'),
                meta: {
                    title: '密码管理',
                    // 设置该路由进入的权限，支持多个权限叠加
                    roles: ["all", "agency"],
                    //表示需要登录
                    requireAuth: true
                }
            }
        ]
    }
]